import { j as o } from "./jsx-runtime.js";
import { p as w, O as A } from "./index2.js";
import { U as E } from "./UserProvider.js";
import { useState as v, useRef as R } from "react";
import { u as T, C as _ } from "./ConversationProvider.js";
import { L as j } from "./LinkDataProvider.js";
import { C as y } from "./ChatbotProvider.js";
function M(t) {
  const e = T({
    serverBaseUrl: t.serverBaseUrl,
    shouldStream: t.shouldStream,
    fetchOptions: t.fetchOptions
  }), [s, i] = v(!1), [c, u] = v(!1), r = R(null), h = t.chatbotName, C = t.isExperimental ?? !0;
  async function m() {
    s || (i(!0), e.conversationId || await e.createConversation());
  }
  function f() {
    return i(!1), !0;
  }
  const [n, l] = v({
    text: "",
    error: ""
  }), d = n.text, g = n.error;
  function I(a) {
    const x = t.maxInputCharacters ? a.length <= t.maxInputCharacters : !0;
    l({
      text: a,
      error: x ? "" : `Input must be less than ${t.maxInputCharacters} characters`
    });
  }
  function b(a) {
    return e.conversationId ? n.error ? (console.error("Cannot add message with invalid input text"), !1) : a.replace(/\s/g, "").length === 0 ? (console.error("Cannot add message with no text"), !1) : c ? (console.error("Cannot add message while awaiting a reply"), !1) : !0 : (console.error("Cannot add message without a conversationId"), !1);
  }
  async function p(a) {
    if (b(a))
      try {
        I(""), u(!0), m(), await e.addMessage({
          role: "user",
          content: a
        });
      } catch (x) {
        console.error(x);
      } finally {
        u(!1);
      }
  }
  return {
    awaitingReply: c,
    canSubmit: b,
    chatbotName: h,
    closeChat: f,
    conversation: e,
    handleSubmit: p,
    inputBarRef: r,
    inputText: d,
    inputTextError: g,
    isExperimental: C,
    maxInputCharacters: t.maxInputCharacters,
    maxCommentCharacters: t.maxCommentCharacters,
    open: s,
    openChat: m,
    setInputText: I
  };
}
function L({
  children: t,
  serverBaseUrl: e,
  shouldStream: s,
  user: i,
  name: c,
  fetchOptions: u,
  ...r
}) {
  const { darkMode: h } = w(r.darkMode), C = 300, m = r.maxInputCharacters ?? C, f = 500, n = r.maxCommentCharacters ?? f, l = M({
    chatbotName: c,
    serverBaseUrl: e,
    shouldStream: s,
    fetchOptions: u,
    maxInputCharacters: m,
    maxCommentCharacters: n
  }), d = r.tck ?? "mongodb_ai_chatbot";
  return /* @__PURE__ */ o.jsx(A, { darkMode: h, children: /* @__PURE__ */ o.jsx(j, { tck: d, children: /* @__PURE__ */ o.jsx(E, { user: i, children: /* @__PURE__ */ o.jsx(y, { ...l, children: /* @__PURE__ */ o.jsx(_, { conversation: l.conversation, children: t }) }) }) }) });
}
export {
  L as C,
  M as u
};
